<template>
  <div class="ugo-form-field">
  <FormViewItem v-if="as_view" :label="label" :required="!!required">
    <BaseLoading v-if="viewFilesLoading" />
    <FormViewFileList v-else :files="viewResolvedFiles" />
  </FormViewItem>
  <FormItem v-else :label="label" :required="!!required">
    <BaseFileSelectFull
        :value="value"
        v-bind="option"
        @input="$emit('input',$event)"
    />
  </FormItem>
  </div>
</template>

<script>
import composedMixin from '../mixins/composed';
import defaultValueMixin from '../mixins/default-value';
import valueDefMixin from '../mixins/value-def';
import asViewMixin from '../mixins/as-view';
import {resolveFormViewFiles} from '../form-view-file-helpers';
export default {
  mixins: [defaultValueMixin, composedMixin, valueDefMixin, asViewMixin],
  cname: '文件',
  corder: 61,
  icon: 'fujian',
  properties: [],
  props: ['fkey', 'label', 'value', 'option', 'old', 'required'],
  data() {
    return {
      viewResolvedFiles: [],
      viewFilesLoading: false,
    };
  },
  watch: {
    value: {
      handler() {
        this.loadViewFiles();
      },
      deep: true,
      immediate: true,
    },
    as_view(v) {
      if (v) {
        this.loadViewFiles();
      }
    },
  },
  methods: {
    getValueDef() {
      return this.valueDefFile();
    },
    getUpdateData() {
      return this.$util.gpt_compare_patched(this.old, this.value);
    },
    loadViewFiles() {
      if (!this.as_view) {
        return;
      }
      this.viewFilesLoading = true;
      resolveFormViewFiles(this, this.value).then((files) => {
        this.viewResolvedFiles = files;
      }).finally(() => {
        this.viewFilesLoading = false;
      });
    },
  },
};
</script>
